import React, { Component } from 'react'
// import Notifications from './Notifications';
import IPFSList from '../projects/IPFSList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class IPFSDashboard extends Component {

    state = {
        searchw: null
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }


    render() {
        const { hashes1, hashes2, auth } = this.props;
        let hashes1_filtered = hashes1 && this.state.searchw ? hashes1.filter(s => s.title.includes(this.state.searchw)) : hashes1
        let hashes2_filtered = hashes2 && this.state.searchw ? hashes2.filter(s => s.title.includes(this.state.searchw)) : hashes2
        if (!auth.uid) return <Redirect to={'/signin'} />
        return (
            <div className="grey lighten-5">
                {/* <div className="dashboard container"> */}
                <div className="row">

                    <div className="col s12 m2 offset-m1">
                        <div className="row"></div>
                        <div className="row"></div>
                        <div className="row"></div>
                        <div className="row"></div>
                        <div className="card">
                            <div className="card-content">
                                <div className="input-field">
                                    <label htmlFor="searchw"><FontAwesomeIcon icon="search" /></label>
                                    <input type="text" id="searchw" onChange={this.handleChange} />
                                </div>
                                {/* <p>
                                    <label htmlFor="sortdate">
                                        <input type="checkbox" id="sortdate" onChange={this.handleChange} />
                                        <span>Date</span>
                                    </label>
                                </p>
                                <p>
                                    <label htmlFor="sortalpha">
                                        <input type="checkbox" id="sortalpha" onChange={this.handleChange} />
                                        <span>Alphabet</span>
                                    </label>
                                </p> */}

                            </div>
                        </div>
                    </div>

                    <div className="col s12 m3 offset-m1">
                        <h5 className="header center black-text text-lighten-2">Created by You</h5>
                        <IPFSList hashes={hashes1_filtered} />
                    </div>

                    <div className="col s12 m3">
                        <h5 className="header center black-text text-lighten-2">Created for You</h5>
                        <IPFSList hashes={hashes2_filtered} />
                    </div>

                    {/* <div className="col s12 m5 offset-m1">
						<Notifications notifications={notifications} />
					</div> */}
                    {/* </div> */}
                </div >
            </div >
        )
    }
};

const mapStateToProps = (state) => {
    return {
        hashes1: state.firestore.ordered.hashes1,
        hashes2: state.firestore.ordered.hashes2,
        auth: state.firebase.auth,
        // notifications: state.firestore.ordered.notifications
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect(
        // [
        // {collection: 'projects' },
        // {collection: 'projects', limit: 5, orderBy: ['createdAt', 'desc'], queryParams: ['email2=test2@ninjaplatform.com'] },
        // {collection: 'notifications', limit: 5, orderBy: ['time', 'desc'] }
        // ]
        (props) => [
            { collection: 'hashes', where: ['authorId', '==', props.auth.uid], storeAs: 'hashes1' },
            { collection: 'hashes', where: ['authorId2', '==', props.auth.uid], storeAs: 'hashes2' },
        ]

    ),
)(IPFSDashboard);